<template lang="pug">
  .lg_container
    <global-header></global-header>
    //- banner轮播图
    .swipe_container
      van-swipe(:autoplay="3000" indicator-color="white")
        van-swipe-item(v-for="(url, index) in (!websiteInfo.basicBannerFlag && websiteInfo.basicBannerUrlList && websiteInfo.basicBannerUrlList.length > 0 ? websiteInfo.basicBannerUrlList : imgList)" :key="index")
          img.bannerImg(:src="url")
    //- 导航栏
    .grid_container(:style="'minHeight:'+ minHeight")
      .grid_list
        .grid_item(v-if="websiteInfo.courseFlag" @click="onJump('/courseSystem')")
          .grid_item_box
            img.grid_item_box_img(src="@/assets/home/nav1.png")
          .grid_item_title 课程体系
        .grid_item(v-if="websiteInfo.teacherFlag" @click="onJump('/teacherFaculty')")
          .grid_item_box
            img.grid_item_box_img(src="@/assets/home/nav2.png")
          .grid_item_title 师资力量
        .grid_item(v-if="websiteInfo.studentFlag" @click="onJump('/studentMien')")
          .grid_item_box
            img.grid_item_box_img(src="@/assets/home/nav3.png")
          .grid_item_title 学员风采
        .grid_item(v-if="websiteInfo.trialFlag" @click="onJump('/freeClasses')")
          .grid_item_box
            img.grid_item_box_img(src="@/assets/home/nav4.png")
          .grid_item_title 免费试听
        .grid_item(v-if="websiteInfo.aboutFlag" @click="onJump('/aboutUs')")
          .grid_item_box
            img.grid_item_box_img(src="@/assets/home/nav5.png")
          .grid_item_title 关于我们
        .grid_item(v-if="websiteInfo.contactFlag" @click="onJump('/contactUs')")
          .grid_item_box
            img.grid_item_box_img(src="@/assets/home/nav6.png")
          .grid_item_title 联系我们
    <global-footer></global-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
export default {
  name: 'Home',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  computed: {
    ...mapGetters(['websiteInfo'])
  },
  created() {
    window.addEventListener('message', e => {
      if (e.data && typeof e.data === 'string' && !e.data.type) {
        const data = Object.assign(
          {
            logoUrl: this.logoUrl,
            wechat: this.wechat
          },
          JSON.parse(e.data)
        )
        data.basicBannerUrlList = data.basicBannerUrlList.map(e => e.fileUrl)
        data.courseBannerUrlList = data.courseBannerUrlList.map(e => e.fileUrl)
        data.studentBannerUrlList = data.studentBannerUrlList.map(e => e.fileUrl)
        data.teacherBannerUrlList = data.teacherBannerUrlList.map(e => e.fileUrl)
        data.studentVideoUrlList = data.studentVideoUrlList.map(e => e.fileUrl)
        data.schoolImageUrlList = data.schoolImageUrlList.map(e => e.fileUrl)
        data.schoolEnvUrlList = data.schoolEnvUrlList.map(e => e.fileUrl)
        this.$store.commit('SET_WEBSITEINFO', data)
      }
    })
  },
  data() {
    return {
      imgList: [require('@/assets/banner/home_banner.png')],
      proportion: (document.documentElement.clientWidth || document.body.clientWidth) / 375,
      minHeight: ''
    }
  },
  mounted() {
    this.minHeight = (window.innerHeight || document.documentElement.clientHeight) - 583 * this.proportion + 'px'
  },
  methods: {
    // 导航跳转
    onJump(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.lg_container {
  .grid_container {
    background-color: #fff;
    padding: 17px 0 4px;
    .grid_list {
      display: flex;
      flex-wrap: wrap;
      .grid_item {
        width: 33.33%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-bottom: 14px;
        &_box {
          width: 84px;
          height: 84px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          &_img {
            width: 100%;
            height: 100%;
          }
        }
        &_title {
          font-size: 14px;
          color: #030303;
          margin-top: 4px;
        }
      }
    }
  }
}
::v-deep .van-swipe {
  .van-swipe-item {
    width: 100%;
    height: 265px;
    .bannerImg {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
}
</style>
